import applySetter from "~/components/forms/utilities/applySetter";

export function sanitizeAndUpdateInput(value) {
  if (this.pastedText && this.sanitizeCharacterInput) {
    // Unicode ranges that we can't/shouldn't display:
    // Control        [\u000A-\u000F]
    // Private Usage  [\uE000-\uF8FF]
    // Specials       [\uFFF0-\uFFFF]

    // Sanitize control chars
    const controlCharSanitize = this.pastedText.replace(
      // eslint-disable-next-line no-control-regex
      /[\u{000A}-\u{000F}]/gu,
      " "
    );
    value = value.replace(this.pastedText, controlCharSanitize);

    // Sanitize unrecognized chars
    const unrecognizedCharSanitize = controlCharSanitize.replace(
      /[\uE000-\uF8FF]|[\uFFF0-\uFFFF]/gu,
      ""
    );
    value = value.replace(controlCharSanitize, unrecognizedCharSanitize);

    if (controlCharSanitize !== unrecognizedCharSanitize) {
      this.characterWarningMessage = true;
    }

    this.pastedText = null;
  }

  this.model = value;
  applySetter.call(this, this.model);
}

export function pasteInput(event) {
  this.pastedText = event.clipboardData.getData("text");
}
